import React from 'react';
import { fieldNames } from '../../../common/config';
import { Form } from 'antd';
import { validateToEndAndPlanEndDate } from '../../../common/lib/fieldValidators';
import { DatePickerCustom } from '../../../../../../../components/DatePickerCustom';

const startDateFieldName = fieldNames.startDate;
const FormItem = Form.Item;

const StartDateField = ({ form }) => {
  return (
    <FormItem
      label="Дата начала"
      style={{ margin: 0 }}
    >
      {form.getFieldDecorator(startDateFieldName, {
        rules: [
          {
            type: 'object',
            required: true,
            message: 'Укажите дату',
          },
          {
            validator: validateToEndAndPlanEndDate(form),
          },
        ],
      })(
        <DatePickerCustom
          size="large"
          style={{ width: '100%' }}
          placeholder="DD.MM.YYYY HH:mm"
          format="DD.MM.YYYY HH:mm"
          showTime={{ format: 'HH:mm', minuteStep: 10 }}
        />
      )}
    </FormItem>
  );
};

export default StartDateField;
